"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDatePickerTimezone = void 0;
var tslib_1 = require("tslib");
var moment_timezone_1 = (0, tslib_1.__importDefault)(require("moment-timezone"));
var react_1 = require("react");
var TimezoneContext_1 = require("../context/TimezoneContext");
function useDatePickerTimezone() {
    var timezone = (0, react_1.useContext)(TimezoneContext_1.TimezoneContext).timezone;
    if (!timezone) {
        return moment_timezone_1.default.tz.guess();
    }
    return timezone;
}
exports.useDatePickerTimezone = useDatePickerTimezone;
//# sourceMappingURL=useDatepickerTimezone.js.map